// ****************************************/
// Newsletter
// ****************************************/

import styled from "styled-components";
import { font, media, underline } from "../Styles";

const NewsletterStyles = styled.section`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100vh;
  pointer-events: none;
  z-index: 10;

  .close {
    position: absolute;
    background: transparent;
    outline: 0;
    border: 0;
    top: 19px;
    right: 10px;
    width: 21px;
    height: 21px;
    z-index: 2;
  }

  .close:hover {
    cursor: pointer;
  }

  .close svg {
    pointer-events: none;
  }

  .background {
    position: relative;
    width: 100%;
    height: 100vh;
    background: ${props => props.theme.greyOpacity100};
    z-index: 2;
  }

  .wrapper {
    position: absolute;
    z-index: 3;
    pointer-events: auto;
    width: 100%;
    height: 50vh;
    background: white;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .wrapper p {
    position: absolute;
    top: 4rem;
    width: 60rem;
    margin: auto;
    font-size: ${font.h1};
    line-height: 1.23;
    ${media.smallDesktopAndBelow`
      top: 40px;
      font-size: ${font.h1Tablet};
      width: calc(100% - 90px);
    `}
    ${media.tabletLandscapeAndBelow`
      top: 20px;
    `}
    ${media.mobileOnly`
      font-size: ${font.h1Mobile};
    `}
  }

  .wrapper .input-wrapper {
    position: relative;
    width: 60rem;
    ${media.smallDesktopAndBelow`
      width: calc(100% - 90px);
    `}
  }

  .wrapper .input-wrapper button {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    border: 0;
    outline: 0;
    background: transparent;
    width: 2.8rem;
    height: 2.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    ${media.smallDesktopAndBelow`
      width: 35px;
      height: 35px;
    `}
  }

  .wrapper .input-wrapper button svg {
    width: 2.1rem;
    height: 2.1rem;
    pointer-events: none;
    ${media.smallDesktopAndBelow`
      width: 21px;
      height: 21px;
    `}
  }

  .submit-wrapper {
    position: relative;
    width: calc(100% - 90px);
  }

  .submit-wrapper button {
    width: 100%;
  }

  .submit-wrapper > span {
    position: absolute;
    top: calc(50% + 30px);
    transform: translateY(-50%);
    left: 0;
    font-size: ${font.p};
    ${media.smallDesktopAndBelow`
      font-size: ${font.pMobile};
    `}
  }
`;

export default NewsletterStyles;
